import { API_ROOT } from '../../config';
import { ssFetchJSON } from '../../modules/ssFetch';

export type CheckoutAppointmentPreviewApiResponse = {
  applicable_credit: '0.00';
  discount?: {
    code: string;
    amount: string;
  }
};

export function checkoutAppointmentPreview(
  appointmentId: number,
  cost: number,
): Promise<CheckoutAppointmentPreviewApiResponse> {
  const url = new URL(`/api/v1/checkout/preview/appointment/${appointmentId}`, API_ROOT);
  return ssFetchJSON(url.toString(), cost ? { params: { cost } } : null);
}
